<template>
<div>
    <Breadcrumbs main="Sales" submain="Return" title="Sales Return" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="d-flex flex-row flex-wrap px-4 py-4" style="gap: 12px;">
                        <span :class="['tab-item', { active: selectedTab === 'delivery_list' }]"  @click="selectTab('delivery_list')">Delivery List</span>
                        <span :class="['tab-item', { active: selectedTab === 'return_list' }]"  @click="selectTab('return_list')">Return List</span>
                        <span :class="['tab-item', { active: selectedTab === 'market_return' }]"  @click="selectTab('market_return')">Market Return</span>
                    </div>   

                   <div>
                     <DeliveryList v-if="selectedTab === 'delivery_list'" tabs="delivery_list"/>
                   </div>
                   <div>
                        <ReturnList v-if="selectedTab === 'return_list'" tabs="return_list"/>
                   </div>
           

                    
                </div>
            </div>
        </div>
    </div>
   
</div>
</template>

<script>
import DeliveryList from './delivery-list.vue';
import ReturnList from './return-list.vue';

export default {
components: {
    DeliveryList,
    ReturnList
  },
  data() {
    return {
      selectedTab: 'delivery_list' // default
    };
  },

  watch: {
    
    '$route.query.tabs': {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal !== this.selectedTab) {
          this.selectedTab = newVal;
        }
      }
    },

    
    selectedTab(newVal) {
      if (this.$route.query.tabs !== newVal) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            tabs: newVal
          }
        }).catch(() => {});
      }
    }
  },

  methods: {
    selectTab(tab) {
      this.selectedTab = tab;
    }
  }
};
</script>

<style scoped>
.tab-item {
  font-weight: 400;
  cursor: pointer;
  position: relative;
  padding-bottom: 4px;
  
}

/* underline animation */
.tab-item::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0%;
  height: 2px;
  background-color: #0d6efd;
  transition: width 0.3s ease;
}

/* active tab */
.tab-item.active {
  font-weight: 500;
}

/* show underline when active */
.tab-item.active::after {
  width: 100%;
}
</style>
